import { Box, styled, Typography, Button } from '@mui/material';

import { theme } from 'styles';

export const InputW = styled(Box)`
  width: 47%;

  @media (max-width: 1023px) {
    width: 100%;
    margin-bottom: 24px;
  }
`;

export const PhoneInputW = styled(Box)`
  &:first-of-type {
    max-width: 132px;

    @media (max-width: 1023px) {
      max-width: 76px;
    }
  }

  &:nth-of-type(2) {
    width: 100%;
    max-width: 65%;
  }

  @media (max-width: 1023px) {
    margin-bottom: 24px;
  }
`;

export const PasswordInputW = styled(Box)`
  width: 100%;
`;

export const WranDescription = styled(Typography)`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.palette.info.main};
`;

export const SignUpButton = styled(Button)`
  width: 100%;
  height: 50px;
  border-radius: 4px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: none;

  &:hover {
    box-shadow: none;
  }
`;
